import React from "react"
import { Icon, Popup, Progress } from "semantic-ui-react"
import shop from "shop/shop"
import MediaQuery from "react-responsive"

const MinOrderFreeValue = ( { sum } ) => {
  if ( !shop.config.MIN_ORDER_VALUE ) return null
  const prc = (Number(sum) / shop.config.MIN_ORDER_FREE_VALUE) * 100
  const aboveMin = Number(sum) > shop.config.MIN_ORDER_FREE_VALUE
  if ( aboveMin  ) return null
  // return <div>{prc}</div>
  return <div className="pt0">
    <MediaQuery minWidth={768}>
      <div>
        <div className="ml0">
          <Progress size="medium"  className="blue" percent={prc}/>
        </div>
      </div>
    </MediaQuery>
  </div>
}

export default MinOrderFreeValue


// WEBPACK FOOTER //
// ./src/theme/hvz/components/Cart/MinOrderFreeValue.js